import { useState } from "react";
import api from "../../utils/api";

export default function PostCommentInput({
  postId,
  onSuccess,
}) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const trimmed = text.trim();

    if (!postId || !trimmed || loading) return;

    try {
      setLoading(true);

      const res = await api.post("/api/comments", {
        postId,
        text: trimmed,
      });

      const createdComment = res.data?.data;

      // Clear input immediately
      setText("");

      // Instead of forcing reload,
      // send created comment to parent
      if (onSuccess) {
        onSuccess(createdComment);
      }

    } catch (err) {
      console.error("Comment failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="comment-input-row">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Write a comment..."
        disabled={loading}
        rows={1}
        style={{ resize: "none" }}
      />

      <button
        onClick={submit}
        disabled={loading || !text.trim()}
        className="comment-submit-btn"
      >
        {loading ? "Posting..." : "Post"}
      </button>
    </div>
  );
}
